import * as React from 'react';

export const ConnectMetaContext = React.createContext<(() => void) | null>(null);

export function useConnectMetaLauncher(): (() => void) | null {
  return React.useContext(ConnectMetaContext);
}
